<!--
  ~ Copyright (c) 2023 D2ArmorPicker by Mijago.
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as published
  ~ by the Free Software Foundation, either version 3 of the License, or
  ~ (at your option) any later version.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program.  If not, see <http://www.gnu.org/licenses/>.
  -->
<div *ngFor="let itemGroup of exotics; let i = index" [@listAnimation]="itemGroup.length">
  <img
    class="exoticIcon {{ selectedExotics.indexOf(-2) > -1 ? 'selected' : '' }}"
    *ngIf="i === 0"
    src="assets/icons/exotic_helmet.jpg"
    matTooltip="Force to use ANY exotic (that is NOT a class item)"
    #tooltip="matTooltip"
    (click)="selectExotic([-2], $event)" />
  <img
    class="exoticIcon {{ selectedExotics.indexOf(-1) > -1 ? 'selected' : '' }}"
    *ngIf="i === 0"
    src="assets/icons/empty_modslot.png"
    matTooltip="Force to use NO exotic at all"
    #tooltip="matTooltip"
    (click)="selectExotic([-1], $event)" />
  <span class="container" *ngFor="let exotic of itemGroup">
    <app-item-icon
      [itemHash]="exotic.items[0].hash"
      [ngClass]="{
        exoticIcon: true,
        selected: selectedExotics.indexOf(exotic.items[0].hash) > -1,
        'vendor-item': !exotic.inInventory && includeVendorRolls && exotic.inVendor,
        'collection-item': !exotic.inInventory && includeCollectionRolls && exotic.inCollection,
        disabled: !(
          exotic.inInventory ||
          (includeCollectionRolls && exotic.inCollection) ||
          (includeVendorRolls && exotic.inVendor)
        ),
      }"
      [exoticTooltip]="exotic.items[0]"
      [exoticTooltipInVendor]="!exotic.inInventory && includeVendorRolls && exotic.inVendor"
      [exoticTooltipInCollection]="
        !exotic.inInventory && includeCollectionRolls && exotic.inCollection
      "
      (click)="
        (exotic.inInventory || (includeCollectionRolls && exotic.inCollection)) &&
          selectExotic(getHashesForExotic(exotic), $event)
      "></app-item-icon>
    <div
      class="item-source-overlay"
      *ngIf="!exotic.inInventory"
      [class.vendor-item]="includeVendorRolls && exotic.inVendor"
      [class.collection-item]="includeCollectionRolls && exotic.inCollection"></div>
  </span>
</div>

<!-- Exotic Class Item Perk Selection -->
<div *ngIf="hasSelectedExoticClassItem()" class="exotic-class-item-perks">
  <h4>Exotic Class Item Perks</h4>
  <div class="perk-selectors">
    <mat-form-field appearance="outline">
      <mat-label>First Perk</mat-label>
      <mat-select
        [value]="selectedExoticPerks[0]"
        (selectionChange)="setExoticPerk(0, $event.value)">
        <mat-option [value]="anyPerkValue">Any</mat-option>
        <mat-option *ngFor="let perk of availableFirstPerks" [value]="perk.value">
          {{ perk.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Second Perk</mat-label>
      <mat-select
        [value]="selectedExoticPerks[1]"
        (selectionChange)="setExoticPerk(1, $event.value)">
        <mat-option [value]="anyPerkValue">Any</mat-option>
        <mat-option *ngFor="let perk of availableSecondPerks" [value]="perk.value">
          {{ perk.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>

<div class="exotic-actions">
  <button
    mat-raised-button
    color="primary"
    [disabled]="refreshInventoryInProgress"
    matTooltip="Reload your inventory from the API."
    (click)="refreshInventory()">
    <mat-spinner
      *ngIf="refreshInventoryInProgress"
      diameter="18"
      class="button-spinner"></mat-spinner>
    <mat-icon *ngIf="!refreshInventoryInProgress">refresh</mat-icon>
    Refresh Inventory
  </button>

  <button
    mat-raised-button
    color="primary"
    [disabled]="importEquippedExoticInProgress"
    matTooltip="Select the exotic currently equipped on your character."
    (click)="importEquippedExotic()">
    <mat-spinner
      *ngIf="importEquippedExoticInProgress"
      diameter="18"
      class="button-spinner"></mat-spinner>
    <mat-icon *ngIf="!importEquippedExoticInProgress">input</mat-icon>
    Import Equipped Exotic
  </button>
</div>
<br />
<div>
  <mat-slide-toggle
    color="warn"
    [checked]="enforceFeaturedLegendaryArmor"
    (change)="setEnforceFeaturedLegendaryArmor($event.checked)">
    Enforce featured <span class="legendary-label">legendary</span> armor only
  </mat-slide-toggle>
</div>

<div>
  <mat-slide-toggle
    color="warn"
    [checked]="enforceFeaturedExoticArmor"
    (change)="setEnforceFeaturedExoticArmor($event.checked)">
    Enforce featured <span class="exotic-label">exotic</span> armor only
  </mat-slide-toggle>
</div>

<div class="minispace"></div>

<div>
  <mat-slide-toggle
    color="primary"
    [checked]="includeCollectionRolls"
    (change)="setAllowCollectionRolls($event.checked)">
    Include <u>exotic</u> collection rolls
  </mat-slide-toggle>
</div>
<div>
  <mat-slide-toggle
    color="primary"
    [checked]="includeVendorRolls"
    (change)="setAllowVendorItems($event.checked)">
    Include <u>legendary and exotic</u> vendor armor (slower)
  </mat-slide-toggle>
</div>

<div class="minispace"></div>
<div>
  <mat-slide-toggle
    color="primary"
    [checked]="allowLegacyLegendaryArmor"
    (change)="setAllowLegacyLegendaryArmor($event.checked)">
    Include legacy (Armor 2.0) <span class="legendary-label">legendary</span> armor
  </mat-slide-toggle>
</div>
<div>
  <mat-slide-toggle
    color="primary"
    [checked]="allowLegacyExoticArmor"
    (change)="setAllowLegacyExoticArmor($event.checked)">
    Include legacy (Armor 2.0) <span class="exotic-label">exotic</span> armor
  </mat-slide-toggle>
</div>
<div>
  <mat-slide-toggle
    color="primary"
    [checked]="allowBlueArmorPieces"
    (change)="setAllowBlueArmorPieces($event.checked)">
    Include white, blue and green items
  </mat-slide-toggle>
</div>
<div>
  <mat-slide-toggle
    color="primary"
    [checked]="!ignoreSunsetArmor"
    (change)="setIgnoreSunsetArmor(!$event.checked)">
    Include sunset armor
  </mat-slide-toggle>
</div>
